export function formatCount (num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G'
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K'
  }
  return num
}
export function VideoTag () {
  let arr = [
    { key: 'talk', name: 'BKK.TALK' },
    { key: 'eat', name: 'FOOD STORIES' },
    { key: 'go', name: 'PLACE TO GO' },
    { key: 'play', name: 'PLAY TIME' },
    { key: 'shop', name: 'THE SELECTED' }
  ]

  return arr
}
